var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDispatchedForm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 21,
  viewBox: "0 0 25 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#434341",
  fillRule: "evenodd",
  d: "M11.886 19.45v-4.164h-.323c-4.308 0-7.034 1.068-8.984 4.63-.378.699-.89.808-1.368.808-.591 0-1.136-.524-1.136-1.461 0-8.053 3.484-13.078 11.488-13.078h.323v-4.12c0-.73.557-1.341 1.325-1.341.545 0 .88.273 1.513.785l8.782 8.043c.413.403.569.807.569 1.177 0 .36-.156.763-.569 1.167l-8.782 8.12c-.568.47-.99.708-1.537.708-.744 0-1.301-.546-1.301-1.275"
})));
export default SvgDispatchedForm;